import { render, staticRenderFns } from "./cowInseminatedBetweenTwoDays.vue?vue&type=template&id=7228d45e&scoped=true&"
import script from "./cowInseminatedBetweenTwoDays.vue?vue&type=script&lang=js&"
export * from "./cowInseminatedBetweenTwoDays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7228d45e",
  null
  
)

export default component.exports